import { render, staticRenderFns } from "./AttachPhotosBox.vue?vue&type=template&id=dd6812ee&"
import script from "./AttachPhotosBox.vue?vue&type=script&lang=js&"
export * from "./AttachPhotosBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports